// cliente (frontend)
import API from 'utils/api';
import { onError } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

/**
 * POST Descargar PDF General
 * @param {integer} entidad
 * @param {string} title
 * @param {array} cols
 * @param {array} values
 * @param {string} date
 * @returns {Promise<Uint8Array|boolean>}
 */
const descargarPDFGeneral = async (entidadId, titleDoc, cols, values, dateFooter) => {
  try {
    const response = await API.post(
      `${API_SCHEME}://${API_HOST}${API_PATH}nominas/descargar-pdf-general`,
      {
        id: entidadId,
        title: titleDoc,
        columns: cols,
        dataTable: values,
        date: dateFooter,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer',
      },
    );
    const pdfData = new Uint8Array(response.data);
    return pdfData;
  } catch (err) {
    onError(err);
    return false;
  }
};

export default descargarPDFGeneral;
